import { UtenteDTO } from "../dto/utenteDTO";

export class CommentoDTO {
    autore: UtenteDTO;
    data: string;
    id: string;
    testo: string;
}